import { parseISO } from 'date-fns';
import {
  RawProductReviews,
  ProductReviews,
  ProductReview,
  RawProductReviewsSummary,
  ProductReviewsSummary,
  ProductSummaryBreakdown,
} from './types/products';

export const mapProductReviews = (data: RawProductReviews): ProductReviews => {
  return {
    items: data.data.map((item): ProductReview => {
      return {
        author: item.author,
        date: parseISO(item.date),
        message: item.message,
        rating: parseFloat(item.rating),
        title: item.title,
      };
    }),
    total: data.total,
    page: data.page,
  };
};

export const mapProductReviewsSummary = (data: RawProductReviewsSummary): ProductReviewsSummary => {
  return {
    count: (data && data.count) ?? 0,
    rating: (data && data.rating) ?? 0,
    breakdown: Object.entries((data && data.breakdown) ?? {})
      .sort((a, b) => parseInt(b[0].replace('rating', '')) - parseInt(a[0].replace('rating', '')))
      .reduce((acc: ProductSummaryBreakdown, [key, value]) => {
        const rating = key.replace('rating', '');
        acc[rating] = value;
        return acc;
      }, {}),
  };
};
